import React, {Component} from 'react';
import '../css/Disclaimer.css';

class Disclaimer extends Component {
	render() {
		return (<div className="app__disclaimer">
			<span className='app__button-reset app__disclaimer--toggle'>
				{this.props.content.disclaimerTitle}
			</span>
			<div className="app__disclaimer-copy">
				<p>{this.props.content.disclaimerText}</p>
			</div>
		</div>);
	}
}

export default Disclaimer;



// WEBPACK FOOTER //
// ./src/components/Disclaimer.js